import { END_POINT_SEVER } from "../constants";
import axios from "axios";
import {  WarningNetworkFailure } from "../helpers/alertseet";
export const get_branch = async (branchId, token) => {
  try {
    const url = `${END_POINT_SEVER}/api/branch/get/${branchId}`;
    const res = await axios.get(url, {
      headers: { authorization: `Bearer ${token}` },
    });
    return res.data;
  } catch (error) {
    if (error.message === "Network Error") {
      WarningNetworkFailure();
    }
    console.error("error", error);
    return { error: true };
  }
};
